import React from "react";

import land1 from "../images/unicorn Aerocit.jpg";
import land2 from "../images/SRG COMPLEX.jpg";
import land3 from "../images/land.jpg";


import {
  ArrowRight,
  Map,
  Maximize,
  BookOpen,
  Send,
  ChevronsRight,
} from "lucide-react";

const projects = [
  {
    title: "Unicorn Aerocity Kolkata",
    location: "Airport Near Kolkata",
    image: land1,
    units: "500+ Plots",
    size: "1000 to 4000 SQ.FT",
   brochure: "/brochure-page",
    explore: "/UnicornAerocity",
  },

  {
    title: "SRG Complex",
    location: "Krishnagar, Nadia",
    image: land2,
    units: "55+ Plots",
    size: "3BHK, 4BHK",
    // brochure: "/brochure/srg.pdf",
    explore: "#",
  },

  {
    title: "Khapur, Gobrapota Land",
    location: "Krishnagar, Nadia",
    image: land3,
    units: "8 Plots",
    size: "1400 to 4000 SQ.FT",
    // brochure: "/brochure/sima.pdf",
    explore: "#",
  },
];

function PropertyCards() {
  return (
    <section className="property-section">
      <div className="property-grid">
        {projects.map((item, index) => (
          <div className="property-card" key={index}>
            
            {/* IMAGE */}
            <div className="image-box">
              <img src={item.image} alt={item.title} />
            </div>

            {/* CONTENT */}
            <div className="card-content">
              <div className="title-row">
                <div>
                  <h4>{item.title}</h4>

                  <p className="location">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      style={{
                        color: "#D8A844",
                        marginRight: "6px",
                      }}
                      fill="currentColor"
                      className="bi bi-geo-alt"
                      viewBox="0 0 16 16"
                    >
                      <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                      <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                    </svg>

                    {item.location}
                  </p>
                </div>

                <ArrowRight className="arrow" size={32} />
              </div>
            </div>

            {/* INFO */}
            <div className="info-row">
              <div className="info-box">
                <Map size={27} color="#d5ad3d" />

                <div>
                  <h5>{item.units}</h5>
                  <p>Total Units</p>
                </div>
              </div>

              <div className="info-box">
                <Maximize size={30} color="#d5ad3d" />

                <div>
                  <h6>{item.size}</h6>
                  <p>Plot Size</p>
                </div>
              </div>
            </div>

            {/* BUTTONS */}
            <div className="button-row me-2">

              {/* BROCHURE */}
              <a
                href={item.brochure}
                target="_blank"
                rel="noreferrer"
                className="btn-link"
              >
                <button>
                  Brochure <BookOpen size={16} />
                </button>
              </a>

              {/* ENQUIRY */}
              <a
                href="tel:8371830744"
                className="btn-link"
              >
                <button className="gold">
                  Enquiry <Send size={16} />
                </button>
              </a>

              {/* EXPLORE */}
              <a
                href={item.explore}
                target="_blank"
                rel="noreferrer"
                className="btn-link"
              >
                <button>
                  Explore <ChevronsRight size={16} />
                </button>
              </a>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PropertyCards;